import { createUserExistenceQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserExistenceQuery = createUserExistenceQuery(HTTP_CONFIG.API.Consumer.url)
